export default __webpack_public_path__ + "static/media/footerLogo.c54941bd.png";